namespace GeniuzPOS.Inventory {
    export class IcStockTransferColumns {
        static columnsKey = 'Inventory.IcStockTransfer';
    }
}
